import React, { useState, useEffect } from "react";
// import UsePanel from "./UserPanel";
import UserPanel from "../Dashboard/UserPanel";
// import OrderStatus from "./OrderStatus";
import OrderStatus from "../Dashboard/OrderStatus";
// import Notifications from "./Notifications";
// import SocialSource from "./SocialSource";
import SocialSource from "../Dashboard/SocialSource";
// import OverView from "./OverView";
import OverView from "../Dashboard/OverView";
// import RevenueByLocation from "./RevenueByLocation";
// import LatestTransation from "./LatestTransation";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
} from "reactstrap";

import SimpleLineChart from "../AllCharts/rechart/SimpleLineChart";
import SimpleAreaChart from "../AllCharts/rechart/SimpleAreaChart";
import MixBarChart from "../AllCharts/rechart/MixBarChart";
import VerticalComposedChart from "../AllCharts/rechart/VerticalComposedChart";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PieChart from "../AllCharts/apex/PieChart";
// import QualityLogs from "./qualityLogs";

const QualityDashboard = () => {
      const authToken =localStorage.getItem("access");
  //const authToken = JSON.parse(localStorage.getItem("authUser")).token;

  const [machines, setMachines] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState("");

  const fetchUser = async () => {
    try {
      const authToken = JSON.parse(localStorage.getItem("authUser")).token;
      // Fetch data from your API
      const response = await fetch("http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/user/profile", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`, // Replace with your actual token
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);

        setSelectedMachine(data.machine_name);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [partsData, setPartsData] = useState({
    good_parts: 0,
    bad_parts: 0,
    total_parts: 0,
    total_running_hours: 0,
    good_parts_ago: 0,
    bad_parts_ago: 0,
    total_parts_ago: 0,
    total_running_hours_ago: 0,
    total_parts_1st_shift: 0,
    total_parts_2st_shift: 0,
    total_parts_3st_shift: 0,
  });

  const [totalpartsData, setTotalPartsData] = useState({
    total_parts_1st_shift: 0,
    total_parts_2st_shift: 0,
    total_parts_3st_shift: 0,
  });

  const fetchMachines = async () => {
    try {
      // Fetch data from your API
      const response = await fetch(
        "http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/user/machine/name",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();

        // Check if the arrays are defined before setting them in the state
        setMachines(data);

        console.log(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchMachineData = async () => {
    try {
      // Fetch data from your API
      const response = await fetch("http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/machine/data", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`, // Replace with your actual token
        },
      });

      if (response.ok) {
        const data = await response.json();
        const part_data = {
          good_parts: data.good_parts ? data.good_parts : 0,
          bad_parts: data.bad_parts ? data.bad_parts : 0,
          total_parts: data.total_parts ? data.total_parts : 0,
          total_running_hours: data.total_running_hours
            ? data.total_running_hours
            : 0,
          good_parts_ago: data.good_parts_ago ? data.good_parts_ago : 0,
          bad_parts_ago: data.bad_parts_ago ? data.bad_parts_ago : 0,
          total_parts_ago: data.total_parts_ago ? data.total_parts_ago : 0,
          total_running_hours_ago: data.total_running_hours_ago
            ? data.total_running_hours_ago
            : 0,
          total_parts_1st_shift: data.total_parts_1st_shift
            ? data.total_parts_1st_shift
            : 0,
          total_parts_2st_shift: data.total_parts_2st_shift
            ? data.total_parts_2st_shift
            : 0,
          total_parts_3st_shift: data.total_parts_3st_shift
            ? data.total_parts_3st_shift
            : 0,
        };
        const total_part_data = {
          total_parts_1st_shift: data.total_parts_1st_shift
            ? data.total_parts_1st_shift
            : 0,
          total_parts_2st_shift: data.total_parts_2st_shift
            ? data.total_parts_2st_shift
            : 0,
          total_parts_3st_shift: data.total_parts_3st_shift
            ? data.total_parts_3st_shift
            : 0,
        };
        setPartsData(part_data);
        setTotalPartsData(total_part_data);
        console.log(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchUser();
    fetchMachines();
    const fetchDataInterval = setInterval(() => {
      fetchMachineData();
    }, 3000); // Fetch data every 3 seconds

    // Cleanup the interval when the component is unmounted or when the dependency array changes
    return () => clearInterval(fetchDataInterval);
  }, []);

  const handleMachineChange = async (event) => {
    const selectedMachineId = event.target.value;

    try {
      const response = await fetch(
        "http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/user/machine/update",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({
            machineId: selectedMachineId,
          }),
        }
      );

      if (response.ok) {
        // Handle success (optional)
        fetchUser();
        fetchMachines();
        fetchMachineData();
        console.log("Machine saved successfully.");
      } else {
        // Handle errors (optional)
        console.error("Error saving machine:", response.statusText);
      }
    } catch (error) {
      console.error("Error saving machine:", error);
    }
  };

  console.log(partsData.good_parts);

  const [partsDataMap, setPartsDataMap] = useState({
    goodPartsList: [],
    badPartsList: [],
    dateTimeList: [],
  });

  const fetchMachineDatamap = async () => {
    try {
      // Fetch data from your API
      const response = await fetch("http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/machine/chart", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`, // Replace with your actual token
        },
      });

      if (response.ok) {
        const data = await response.json();
        const part_data = {
          goodPartsList: data.goodPartsList ? data.goodPartsList : [],
          badPartsList: data.badPartsList ? data.badPartsList : [],
          dateTimeList: data.dateTimeList ? data.dateTimeList : [],
        };

        setPartsDataMap(part_data);
        console.log(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchDataIntervalmap = setInterval(() => {
      fetchMachineDatamap();
    }, 3000); // Fetch data every 3 seconds

    // Cleanup the interval when the component is unmounted or when the dependency array changes
    return () => clearInterval(fetchDataIntervalmap);
  }, []);

  const [isDownloading, setIsDownloading] = useState(false);

  // const downloadFile = async (url, filename) => {
  //   try {
  //     const response = await fetch(url, {
  //       responseType: 'blob',
  //       headers: {
  //         "Content-Type": "application/json",
  //         'Authorization': `Bearer ${authToken}` // Replace with your actual token
  //       },
  //     });
  //     const blob = await response.blob();

  //     // Create a link element and trigger a click to download the file
  //     const a = document.createElement('a');
  //     a.href = window.URL.createObjectURL(blob);
  //     a.download = 'shift_metrics.xlsx';
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);

  //     setIsDownloading(false);

  //   } catch (error) {
  //     console.error('Error downloading file:', error);
  //     // Display an error message to the user
  //   }
  // };

  // const handleDownloadClick = async () => {
  //   setIsDownloading(true);

  //   try {
  //     await downloadFile('http://ec2-35-154-129-107.ap-south-1.compute.amazonaws.com:3003/api/data/performance/download', 'report.xlsx');
  //   } catch (error) {
  //     // Handle errors appropriately
  //   } finally {
  //     setIsDownloading(false);
  //   }
  // };

  console.log(partsData.good_parts);

  document.title = "Quality Dashboard | OptiMize ";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Quality Dashboard" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div>
                    <Row>
                      <Col lg={3}>
                        <div>
                          <label className=" col-form-label">
                            Select Machine
                          </label>
                          <div className="col-md-10">
                            <select className="form-control">
                              <option>Select</option>
                              <option>Large select</option>
                              <option>Small select</option>
                            </select>
                          </div>
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div>
                          <label
                            htmlFor="example-date-input"
                            className=" col-form-label"
                          >
                            From
                          </label>
                          <input
                            className="form-control"
                            type="date"
                            defaultValue="2019-08-19"
                            id="example-date-input"
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div>
                          <label
                            htmlFor="example-date-input"
                            className="col-form-label"
                          >
                            To
                          </label>
                          <input
                            className="form-control"
                            type="date"
                            defaultValue="2019-08-19"
                            id="example-date-input"
                          />
                        </div>
                      </Col>
                      <Col lg={3} className="mt-2 d-flex align-items-end ">
                        <button className="btn btn-info">Submit</button>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={6} md={6}>
              <Card>
                <CardBody>
                  <CardTitle>Top 5 Machines Rejections</CardTitle>
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead>
                        <tr>
                          <th>SN</th>
                          <th>Machines</th>
                          <th>Rejections (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">1</th>
                          <td>IM-3</td>
                          <td>5 %</td>
                        </tr>
                        <tr>
                          <th scope="row">2</th>
                          <td>IM-2</td>
                          <td>0.2 %</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={6} md={6}>
              <Card>
                <CardBody>
                  <CardTitle>Rejection Reasons</CardTitle>
                  <PieChart />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default QualityDashboard;
